import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { FREE_OF_CHARGE_RULE_COLUMN } from '../../../../config/columns';
import {
  FREE_OF_CHARGE_RULE_PATH,
  NEW_FREE_OF_CHARGE_RULE_PATH,
} from '../../../../config/paths';
import {
  clearFreeOfChargeRules,
  getFreeOfChargeRules,
} from '../../../../actions/sales/FreeOfChargeRule';

export const FreeOfChargeRules = ({
  breadcrumbs,
  freeOfChargeRules,
  loading,
  dispatchGetFreeOfChargeRules,
  dispatchClearFreeOfChargeRules,
}) => {
  useLayoutEffect(() => () => dispatchClearFreeOfChargeRules(), []);

  const data = freeOfChargeRules.get('content') || [];
  const pages = freeOfChargeRules.get('totalPages') || null;
  const defaultPageSize = freeOfChargeRules.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Reglas para Servicios a Título Gratuito"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_FREE_OF_CHARGE_RULE_PATH}
      buttonText="Crear / Editar"
      tableStructure={{
        columns: FREE_OF_CHARGE_RULE_COLUMN,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetFreeOfChargeRules,
        modelPath: FREE_OF_CHARGE_RULE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetFreeOfChargeRules: getFreeOfChargeRules,
  dispatchClearFreeOfChargeRules: clearFreeOfChargeRules,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Reglas para Servicios a Título Gratuito',
      href: FREE_OF_CHARGE_RULE_PATH,
    },
  ],
  freeOfChargeRules: SalesUnit.FreeOfChargeRule.getIn(['all', 'content']),
  loading: SalesUnit.FreeOfChargeRule.getIn(['all', 'loading']),
});

FreeOfChargeRules.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  freeOfChargeRules: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetFreeOfChargeRules: PropTypes.func.isRequired,
  dispatchClearFreeOfChargeRules: PropTypes.func.isRequired,
};

FreeOfChargeRules.defaultProps = {
  freeOfChargeRules: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(FreeOfChargeRules);
